var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app1"}},[_c('headerTop'),_c('banner'),_c('div',{staticClass:"container"},[_c('router-view')],1),_c('div',{staticClass:"footer_con"},[_c('foot')],1),_c('chatWindow')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }